import constants from "./constants"

const initialState = {
	error        : null,
	isSending    : false,
	orgMaterials : null

}

export default function (state = initialState, action){
	switch (action.type){
		case (constants.GetOrgMaterialPaged.REQUEST):
			return {
				...state,
				isSending: true
			}
		case (constants.GetOrgMaterialPaged.SUCCESS):
			return {
				...state,
				isSending    : false,
				orgMaterials : action.payload.result
			}
		case (constants.GetOrgMaterialPaged.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		default:
			return state
	}
}